import React, { useMemo } from 'react';

import { Reconnect } from 'src/federation/Reconnect';

import {
  getDailySalesReportTableProps,
  DailySalesReportTableProps,
} from './dailySalesReportTableProps';

export const ReportTable = ({
  venueId,
  selectedEmployeeId,
  selectedChannel,
  reportData,
}: DailySalesReportTableProps) => {
  const props = useMemo(
    () =>
      getDailySalesReportTableProps({ venueId, selectedEmployeeId, selectedChannel, reportData }),
    [venueId, selectedEmployeeId, selectedChannel, reportData],
  );

  return <Reconnect name="ReportTable" props={props} />;
};
